import { Box, Slider } from '@mui/material';

export const VerticalSlider = ({
  numOfSteps,
  currentSliderValue,
  setCurrentSliderValue,
}: {
  numOfSteps: number;
  currentSliderValue: number;
  setCurrentSliderValue: (value: number) => void;
}) => {
  return (
    <Box
      padding='70px 24px'
      className='bg-[var(--mui-palette-background-default)]'
    >
      <Slider
        sx={{
          '& .MuiSlider-rail': {
            height: 'calc(100% + 48px)', // 24px padding top + bottom
            marginTop: '-24px',
            marginBottom: '24px',
            width: '16px',
            backgroundColor: 'var(--mui-palette-background-section)',
            border: 'none',
          },
          '& .MuiSlider-track': {
            backgroundColor: 'var(--mui-palette-background-section)',
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            border: 'none',
            backgroundColor: 'var(--mui-palette-primary-darkerOpacity)',
            '&:hover, &.Mui-focusVisible': {
              boxShadow: 'var(--mui-customShadows-focusRing)',
            },
            '&.Mui-active': {
              boxShadow: 'var(--mui-customShadows-focusRing) !important',
            },
          },
          '& .MuiSlider-mark': {
            width: '3px',
            height: '3px',
            borderRadius: '50%',
            backgroundColor: 'black',
            display: 'block',
          },
          '& .MuiSlider-valueLabel': {
            left: '50% !important',
            transform: 'translate(-50%, -100%) !important',
            top: '-8px !important',
            right: 'auto !important',
          },
        }}
        orientation='vertical'
        aria-label='vertical-slider'
        value={currentSliderValue}
        onChange={(e, newValue) => {
          setCurrentSliderValue(newValue as number);
        }}
        valueLabelFormat={(value) => `${value} - ${value + 4}`}
        valueLabelDisplay='on'
        shiftStep={6}
        step={numOfSteps}
        marks={true}
        min={0}
        max={20}
      />
    </Box>
  );
};
